export { FeaturedHeadToHead } from './FeaturedHeadToHead';
